var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9006 7.00001H34.5511L32.3011 2.50001C31.8011 1.50001 30.7503 0.849609 29.6019 0.849609H18.4009C17.2505 0.849609 16.2017 1.50001 15.7017 2.50001L13.4517 7.00001H6.1002C2.8502 7.00001 0.250702 9.59961 0.250702 12.801V35.4005C0.250702 38.5997 2.8503 41.25 6.1002 41.25H41.9497C45.1489 41.25 47.7992 38.6504 47.7992 35.4005L47.8012 12.801C47.7504 9.59986 45.1508 7.00001 41.9007 7.00001H41.9006ZM24.0001 34.25C18.0996 34.25 13.3011 29.4492 13.3011 23.551C13.3011 17.6505 18.1 12.85 24.0001 12.85C29.9003 12.85 34.6991 17.6508 34.6991 23.549C34.6991 29.4495 29.9003 34.25 24.0001 34.25Z",
    fill: "#F2F2F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2502 17.199C24.551 16.5486 23.4006 16.5486 22.6994 17.199L19.1994 20.4998C18.4494 21.199 18.3986 22.4002 19.0998 23.1502C19.799 23.9002 21.0002 23.951 21.7502 23.2498L22.1506 22.8494V28.3494C22.1506 29.4002 23.0002 30.199 24.0002 30.199C25.051 30.199 25.8498 29.3494 25.8498 28.3494V22.8494L26.2502 23.2498C26.5998 23.5994 27.051 23.7498 27.5002 23.7498C28.0002 23.7498 28.5002 23.5506 28.8498 23.1502C29.549 22.4002 29.5002 21.201 28.7502 20.4998L25.2502 17.199Z",
    fill: "#F2F2F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.83b367c3.svg";
export { ForwardRef as ReactComponent };